/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { FulfillmentServiceData } from '@/models';

import FulfillmentService from './data/fulfillmentServices';

export async function fetchFulfillmentServiceData(id: string): Promise<FulfillmentServiceData> {
  for (const serviceKey in FulfillmentService) {
    if (FulfillmentService.hasOwnProperty(serviceKey)) {
      const service = (FulfillmentService as {
        [key: string]: FulfillmentServiceData,
      })[serviceKey];
      if (service.id === id) {
        return service;
      }
    }
  }
  throw new Error(`Cannot find fulfillment service with given id: ${id}`);
}
